import { ChevronLeftIcon } from "../../assets/icons";
import { IconButton } from "../IconButton";

import "./Modal.scss";

function Modal({
  className,
  containerClassName,
  children,
  title,
  onClose,
  close,
}) {
  return (
    <div className={`modal ${close ? "close" : ""}`}>
      <div className="modal-wrapper">
        <div className="modal-cover"></div>

        <div className={`modal-container ${containerClassName || ""}`}>
          {title ? (
            <div className="modal-header">
              <IconButton icon={<ChevronLeftIcon />} onClick={onClose} />
              <h1>{title}</h1>
            </div>
          ) : null}

          <div
            className={`modal-content ${title ? "" : "no-header"} ${className}`}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Modal;
